import { Module } from '../Module';

Module.instance().directive('tbMouseTrack', <any[]>[
  '$parse',
  ($parse: ng.IParseService) => {
    return {
      link: (scope: ng.IScope, element: JQuery, attr: ng.IAttributes) => {
        // TODO: namespace can come from component using this directive.
        const eventNamespace = '.tbMouseTrack';

        // Note: $parse(attr[]) is the pattern used by angular directives. Not a binding.
        const moveFn = $parse(attr['tbMouseTrack']);
        const enterFn = $parse(attr['tbMouseTrackEnter']);
        const leaveFn = $parse(attr['tbMouseTrackLeave']);

        element.on('mouseenter' + eventNamespace, (enterEvent: JQuery.Event) => {
          enterFn(scope, { $event: enterEvent });
          element.on('mousemove' + eventNamespace, (moveEvent: JQuery.Event) => {
            moveFn(scope, { $event: moveEvent });
          });
        });

        element.on('mouseleave' + eventNamespace, (leaveEvent: JQuery.Event) => {
          element.off('mousemove' + eventNamespace);
          leaveFn(scope, { $event: leaveEvent });
        });
      }
    };
  }
]);
